<template>
  <div class="helpWrap" v-show="visible">
    <div class="helptitle">
      <a href="javascript:;" @click="closehelp">关闭</a>
    </div>
    <div class="helpcontent">
      <p align="center">
        <strong>系统数学公式操作建议及公式和符号输入方法介绍</strong>
      </p>
      <p align="center">
        <strong>数学公式操作建议</strong>
      </p>
      <p style="TEXT-INDENT: 2em">
        <strong>一、插入方式</strong>
      </p>
      <p
        style="TEXT-INDENT: 2em"
      >在答题区域需要插入公式的地方点击鼠标 &rarr; 点击【公式和符号】按钮，弹出选择公式对话框 &rarr; 点击相应的公式进行插入 &rarr; 在公式中输入数字 &rarr; 输入完成将光标移出公式框</p>
      <p style="TEXT-INDENT: 2em">
        <strong>二、输入数字</strong>
      </p>
      <p style="TEXT-INDENT: 2em">1.观察插入公式后鼠标停留的位置，通常有如下图的2种情况，鼠标分别显示在公式前端和末端
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="22"
          height="34"
          src="@/assets/images/doExam/help1.jpg"
        >
        <span lang="EN-US"/>，
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="24"
          height="33"
          src="@/assets/images/doExam/help2.jpg"
        >
        <span lang="EN-US">
          <span lang="EN-US"/>
        </span>。
      </p>
      <p style="TEXT-INDENT: 2em">2.观察公式中需要输入数字的区域的布局，布局通常有3种：左右、上下、左右加上下，如下图：</p>
      <p style="TEXT-INDENT: 2em">左右：
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="22"
          height="34"
          src="@/assets/images/doExam/help3.jpg"
        >
        <span lang="EN-US"/>
      </p>
      <p style="TEXT-INDENT: 2em">上下：
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="23"
          height="35"
          src="@/assets/images/doExam/help4.jpg"
        >
        <span lang="EN-US"/>
      </p>
      <p style="TEXT-INDENT: 2em">左右+上下：
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="23"
          height="32"
          src="@/assets/images/doExam/help5.jpg"
        >
        <span lang="EN-US"/>
      </p>
      <p
        style="TEXT-INDENT: 2em"
      >3.左右区域可以通过键盘上的&larr;、&rarr;方向键进行依次选择，上下布局的可以通过键盘上的&uarr;、&darr;方向键进行选择，也可以通过鼠标点击选择相应的区域进行输入，通常建议通过键盘上的&larr;、&rarr;、&uarr;、&darr;方向键进行选择输入，特别是屏幕较小的情况下。</p>
      <p
        style="TEXT-INDENT: 2em"
      >4.公式内的数字输入完成后，需要点击鼠标将光标移出公式框，然后再继续在答题区域输入其他内容，不要继续在公式输入框内继续输入其他答题内容，如下图1是正确的操作，图2是错误的操作</p>
      <div align="center">
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="471"
          height="41"
          src="@/assets/images/doExam/help6.jpg"
        >
      </div>
      <p style="TEXT-INDENT: 2em">
        <strong>三、删除公式</strong>
      </p>
      <p style="TEXT-INDENT: 2em">点击鼠标将光标移至公式的右侧，点击键盘上的退格键即可。</p>
      <p style="TEXT-INDENT: 2em" align="center">
        <strong>公式和符号输入方法介绍</strong>
      </p>
      <p style="TEXT-INDENT: 2em">
        <strong>一、同一符号的不同表示方式</strong>
      </p>
      <p style="TEXT-INDENT: 2em">下面列举三种类型符号的可替代的表示方式。</p>
      <p style="TEXT-INDENT: 2em">1. 乘法</p>
      <p
        style="TEXT-INDENT: 2em"
      >乘法符号的正确表示方式有三种，分别为&ldquo;&times;&rdquo;、&ldquo;&middot;&rdquo;和&ldquo;*&rdquo;(&ldquo;*&rdquo;的键盘快捷键为&ldquo;Shift+&lsquo;8&rsquo;&rdquo;)。如下图所示：</p>
      <p style="TEXT-ALIGN: center" class="MsoNormal" align="center">
        <span style="FONT-SIZE: 10pt" lang="EN-US"/>
      </p>
      <p align="center">
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="575"
          height="210"
          src="@/assets/images/doExam/help8.png"
        >
      </p>
      <p style="TEXT-INDENT: 2em">2. 除法</p>
      <p
        style="TEXT-INDENT: 2em"
      >除法符号的正确表示方式有三种，分别为&ldquo;&divide;&rdquo;、&ldquo;/&rdquo;和&ldquo;-&rdquo;。如下图所示：</p>
      <p style="TEXT-ALIGN: center" class="MsoNormal" align="center">
        <span style="FONT-SIZE: 10pt" lang="EN-US"/>
      </p>
      <p align="center">
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="573"
          height="240"
          src="@/assets/images/doExam/help9.png"
        >
      </p>
      <p style="TEXT-INDENT: 2em">3. 幂次方</p>
      <p
        style="TEXT-INDENT: 2em"
      >x的a次方的正确表示方式有两种，分别为&ldquo;xa&rdquo;和&ldquo;x^a&rdquo; (&ldquo;^&rdquo;的键盘快捷键为&ldquo;Shift+&lsquo;6&rsquo;&rdquo;)。如下图所示：</p>
      <p style="TEXT-ALIGN: center" class="MsoNormal" align="center">
        <span style="FONT-SIZE: 10pt" lang="EN-US"/>
      </p>
      <p align="center">
        <img
          alt
          width="584"
          height="221"
          src="@/assets/images/doExam/help10.png"
        >
      </p>
      <p style="TEXT-INDENT: 2em">例：x的开方可以写作&ldquo;x^(1/2)&rdquo;。</p>
      <p style="TEXT-INDENT: 2em">
        <strong>二、输入特定公式和符号的快捷方式</strong>
      </p>
      <p
        style="TEXT-INDENT: 2em"
      >下面列举几种输入特定公式和符号的快捷方式，以下操作均在公式和符号框内实现，公式和符号框为点击&ldquo;公式和符号&rdquo;按钮所出现的框，如下图所示：</p>
      <p style="TEXT-INDENT: 31.5pt; BACKGROUND: white" class="MsoNormal" align="center">
        <span style="FONT-SIZE: 10pt" lang="EN-US"/>
      </p>
      <p align="center">
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="565"
          height="194"
          src="@/assets/images/doExam/help11.png"
        >
      </p>
      <p style="TEXT-INDENT: 2em">1. 上标</p>
      <p
        style="TEXT-INDENT: 2em"
      >如，想要输入x的a次方，可以输入&ldquo;x^a&rdquo;，输入&ldquo;^&rdquo;时光标会自动跳到上标位置上去，输入完成之后，可以按Tab键让其退出上标位置，回到正常的位置。如下图所示：</p>
      <p style="TEXT-INDENT: 31.5pt; BACKGROUND: white" class="MsoNormal" align="center">
        <span style="FONT-SIZE: 10pt" lang="EN-US"/>
      </p>
      <p align="center">
        <img
          alt="2016中级职称无纸化考试数学公式操作建议及输入方法介绍 "
          width="550"
          height="209"
          src="@/assets/images/doExam/help11.jpg"
        >
      </p>
      <p style="TEXT-INDENT: 2em">2. 下标</p>
      <p
        style="TEXT-INDENT: 2em"
      >如，想要输入&ldquo;Rm&rdquo;,就可以依次输入&ldquo;R&rdquo;、下划线（下划线的键盘快捷键为&ldquo;Shift+&lsquo;-&rsquo;&rdquo;）和&ldquo;m&rdquo;，输入下划线时光标会自动跳到下标位置上去，输入完成之后，可以按Tab键让其退出下标位置，回到正常的位置。如下图所示：</p>
      <p
        style="TEXT-ALIGN: center; TEXT-INDENT: 31.5pt; BACKGROUND: white"
        class="MsoNormal"
        align="center"
      >
        <span style="FONT-SIZE: 10pt" lang="EN-US"/>
      </p>
      <p align="center">
        <img
          alt
          width="550"
          height="226"
          src="@/assets/images/doExam/help12.png"
        >
      </p>
      <p style="TEXT-INDENT: 2em">3. 分式</p>
      <p style="TEXT-INDENT: 2em">直接输入键盘的&ldquo;/&rdquo;即可。</p>
      <p style="TEXT-INDENT: 2em">4. 乘除号</p>
      <p
        style="TEXT-INDENT: 2em"
      >在公式框中输入&ldquo;\times&rdquo;，再输入空格，就可以输入乘号&ldquo;&times;&rdquo;，在公式框中输入&ldquo;\div&rdquo;，再输入空格，就可以输入除号&ldquo;&divide;&rdquo;。</p>
      <p style="TEXT-INDENT: 2em">5. 其它</p>
      <p style="TEXT-INDENT: 2em">在公式框中输入相应的快捷方式，再输入空格，即可显示出相应的字符。</p>
      <div align="center">
        <table
          class="font1215"
          border="1"
          cellspacing="0"
          bordercolorlight="#000000"
          bordercolordark="#ffffff"
          cellpadding="0"
          width="100%"
          align="center"
        >
          <tbody>
            <tr>
              <td width="282">
                <strong>对应字符</strong>
              </td>
              <td width="301">
                <strong>快捷方式</strong>
              </td>
            </tr>
            <tr>
              <td width="282">&alpha;</td>
              <td width="301">\alpha</td>
            </tr>
            <tr>
              <td width="282">&beta;</td>
              <td width="301">\beta</td>
            </tr>
            <tr>
              <td width="282">&gamma;</td>
              <td width="301">\gamma</td>
            </tr>
            <tr>
              <td width="282">&sigma;</td>
              <td width="301">\sigma</td>
            </tr>
            <tr>
              <td width="282">&delta;</td>
              <td width="301">\delta</td>
            </tr>
            <tr>
              <td width="282">&mu;</td>
              <td width="301">\mu</td>
            </tr>
            <tr>
              <td width="282">&Delta;</td>
              <td width="301">\Delta</td>
            </tr>
            <tr>
              <td width="282">=</td>
              <td width="301">=</td>
            </tr>
            <tr>
              <td width="282">&gt;</td>
              <td width="301">&gt;</td>
            </tr>
            <tr>
              <td width="282">&lt;</td>
              <td width="301">&lt;</td>
            </tr>
            <tr>
              <td width="282">&ge;</td>
              <td width="301">\ge</td>
            </tr>
            <tr>
              <td width="282">&le;</td>
              <td width="301">\le</td>
            </tr>
            <tr>
              <td width="282">&ne;</td>
              <td width="301">\ne</td>
            </tr>
            <tr>
              <td width="282">&asymp;</td>
              <td width="301">\approx</td>
            </tr>
            <tr>
              <td width="282">&sum;</td>
              <td width="301">\sum</td>
            </tr>
            <tr>
              <td width="282">开方</td>
              <td width="301">\sqrt</td>
            </tr>
            <tr>
              <td width="282">开多次根</td>
              <td width="301">\nthroot</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'helpWrap',
  props: {
    visible: { type: Boolean, default: false }
  },
  methods: {
    closehelp() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
.helpWrap {
  line-height: 40px;
  z-index: 1000;
  width: 80%;
  position: absolute;
  top: 50px;
  left: 10%;
  right: 10%;
  background-color: #fff;
  overflow: hidden;
  // border-radius: 10px;
  border: 1px solid #cccccc;
  box-shadow: 0 1px 3px #cccccc;
  .helptitle {
    width: 100%;
    background-color: #1e90ff;
    line-height: 40px;
      overflow: hidden;
    a {
      font-size:16px;
      float: right;
      margin-right: 10px;
      color: #fff;
    }
  }
  .helpcontent {
    width: 100%;
    height: 500px;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>
